/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Words_WrappedInputs */

const en_us2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recap summary week numbers wrapped share`)
};

const pt_br2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retrospectiva resumo semana numeros wrapped compartilhar`)
};

const es_419_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`resumen semana numeros wrapped compartir`)
};

const pt_pt2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retrospetiva resumo semana numeros wrapped partilhar`)
};

const fr_fr2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bilan resume semaine chiffres recap partager`)
};

const de_de2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rückblick zusammenfassung woche zahlen wrapped teilen`)
};

const it_it2_search_words_wrapped = /** @type {(inputs: Search_Words_WrappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`riepilogo resoconto settimana numeri wrapped condividi`)
};

/**
* | output |
* | --- |
* | "recap summary week numbers wrapped share" |
*
* @param {Search_Words_WrappedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_words_wrapped = /** @type {((inputs?: Search_Words_WrappedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Words_WrappedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_words_wrapped(inputs)
	if (locale === "es-419") return es_419_search_words_wrapped(inputs)
	if (locale === "pt-PT") return pt_pt2_search_words_wrapped(inputs)
	if (locale === "fr-FR") return fr_fr2_search_words_wrapped(inputs)
	if (locale === "de-DE") return de_de2_search_words_wrapped(inputs)
	if (locale === "it-IT") return it_it2_search_words_wrapped(inputs)
	return en_us2_search_words_wrapped(inputs)
});
export { search_words_wrapped as "search.words_wrapped" }